<ol class="list-unstyled">
  <li *ngFor="let proposta of propostas">
      <app-ficha-card-home [proposta]="proposta" [idFase]="idFase"></app-ficha-card-home>
  </li>
</ol>
<div *ngIf="propostas.length === 0">
  <h2>Não foram encontradas propostas para essa fase</h2>
</div>
